import React from "react";
import { getStaticUrl } from "js/config";

export type UpgradeIconProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    style?: React.CSSProperties
};

const UpgradeIcon = React.forwardRef<HTMLImageElement, UpgradeIconProps>(function UpgradeIcon(
    { style, className = "icon", ...rest },
    ref
) {
    return (
        <img
            ref={ref}
            src={getStaticUrl("/images/upgrade-icon.svg")}
            style={style}
            className={className}
            {...rest}
        />
    );
});

// Mark as a button icon so parent Button can detect it like a native <img>
(UpgradeIcon as any).upgradeIcon = true;

export default UpgradeIcon;
